import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent} from '@utils-lib';
import {AppNameEnum, OrgantraegerDetail, PersonenTypEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-organschaftsverhaeltnisse-form',
    templateUrl: './organschaftsverhaeltnisse-form.component.html'
})
export class OrganschaftsverhaeltnisseFormComponent extends FormBaseComponent<OrgantraegerDetail> implements OnInit {

    @Input()
    public organtraegerDetail: OrgantraegerDetail;

    public personenTypEnum = PersonenTypEnumLabels;
    public showError1: boolean;
    public showError2: boolean;
    private appEnum: AppNameEnum;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly currentRoute: ActivatedRoute,
                private readonly cd: ChangeDetectorRef,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
        this.appEnum = ComponentHelper.getAppEnum(this.currentRoute.snapshot);
    }

    public get showWirtschaftsIdNummer(): boolean {
        return !(this.appEnum === AppNameEnum.FragebogenKapG
            && this.data?.personenTyp === PersonenTypEnumLabels.NatPers);
    }

    ngOnInit(): void {
        this.data = this.organtraegerDetail;
        super.ngOnInit();
        this.validateErrors();
    }

    onDataChanged(): void {
        this.cd.detectChanges();
        this.validateErrors();
    }

    public onPersonTypeChange(): void {
        if (this.data.personenTyp === PersonenTypEnumLabels.NatPers) {
            this.data.juristischePerson = null;
        } else if (this.data.personenTyp === PersonenTypEnumLabels.NNatPers) {
            this.data.natuerlichePerson = null;
        } else {
            this.data.natuerlichePerson = null;
            this.data.juristischePerson = null;
            this.data.steuernummer = null;
            this.data.wirtschaftsIdNummer = null;
            this.data.ustIdentifikationsnummer = null;
            this.data.isUmStOrgantraegerIdentischKStUndGewStOrgantraeger = null;
            this.data.isUmsatzsteuerOrgangesellschaft = null;
            this.data.datumGewinnAbfVertrag = null;
            this.data.beginnUStOrganschaft = null;
        }
        this.onDataChanged();
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({});
    }

    private validateErrors(): void {
        if (this.currentRoute.snapshot.data.data.organtraeger.length > 1) {
            this.showError1 = this.isAnyUmStOrgantraegerIdentisch();
            this.showError2 = this.areAllOrgantraegerUSt() || this.areAllOrgantraegerKStGewSt();
        } else {
            this.showError1 = false;
            this.showError2 = false;
        }
    }

    private isAnyUmStOrgantraegerIdentisch(): boolean {
        const find = this.currentRoute.snapshot.data.data.organtraeger
            .find(item => item.isUmStOrgantraegerIdentischKStUndGewStOrgantraeger);
        return (find !== undefined);
    }

    private areAllOrgantraegerUSt(): boolean {
        const filtered = this.currentRoute.snapshot.data.data.organtraeger.filter(item => !item.isUmsatzsteuerOrgangesellschaft);
        return (filtered.length === 0);
    }

    private areAllOrgantraegerKStGewSt(): boolean {
        const filtered = this.currentRoute.snapshot.data.data.organtraeger.filter(item => !item.isKStUndGewStOrgangesellschaft);
        return (filtered.length === 0);
    }

}
